/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  BuiltinExclusionEntry,
  BuiltinExclusionEntry$inboundSchema,
} from "./builtinexclusionentry.js";

/**
 * A named group of built-in exclusion rules.
 */
export type BuiltinExclusionCategory = {
  /**
   * The rules in this category.
   */
  entries: Array<BuiltinExclusionEntry>;
  /**
   * Human category label, e.g. "Test credit cards".
   */
  label: string;
};

/** @internal */
export const BuiltinExclusionCategory$inboundSchema: z.ZodMiniType<
  BuiltinExclusionCategory,
  unknown
> = z.object({
  entries: z.array(BuiltinExclusionEntry$inboundSchema),
  label: z.string(),
});

export function builtinExclusionCategoryFromJSON(
  jsonString: string,
): SafeParseResult<BuiltinExclusionCategory, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BuiltinExclusionCategory$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BuiltinExclusionCategory' from JSON`,
  );
}
